import React, {useState, useEffect} from 'react';
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import { getToken, onMessageListener } from '../../utils/pushNotification';
import * as notificationActions from '../../Redux/Actions/notification';
import { toastMessage } from '../../utils/toast';
import Modal from '../Ui/Modal';
import ReasonModal from './reasonModal';

const JobRequest = ({history, userID}) => {
    const [fcmToken, setFcmToken] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [jobID, setJobID] = useState('');
    const [jobData, setJobData] = useState('');
    const [jobNotifyModal, setJobNotifyModal] = useState(false);
    const [reason, setReason] = useState('');
    const [reasonModal, setReasonModal] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {getToken(setFcmToken);}, []);

    useEffect(() => {
        let payload = {
            id: userID, fcmToken
        };
        let oldToken = localStorage.getItem('fcmToken');
        (oldToken !== fcmToken) && (fcmToken !== '') && notificationActions.updateToken(payload).then(res => {
            localStorage.setItem('fcmToken', fcmToken);
            if(res && res.data){
                toastMessage('success', 'Your notification status updated');
            }else{
                toastMessage('error', 'Unable to update the FCM token');
            }
        });
    }, [fcmToken, userID]);

    onMessageListener().then(payload => {
        let body = JSON.parse(payload.notification.body);
        if(body.jobId){
            setJobTitle(payload.notification.title);
            setJobID(body.jobId);
            setJobData(body.json);
            setJobNotifyModal(true);
        }else{
            toastMessage('success', "New Job notification received, Please Refresh dashboard!");
        }
    }).catch(err => console.log('failed: ', err));

    const closeModal = () =>{
        setJobNotifyModal(false);
        setReasonModal(false);
    };
    
    const updateJobStatus = (status) => {
        setJobNotifyModal(false);
        setReasonModal(false);
        let payload = {
            JobId: jobID,
            UserId: userID,
            Status: status
        };
        payload = (status === 'Declined') ? {...payload, Reason: reason} : payload;
        jobsActions.UpdateAgentSelectionStatus(payload).then(res => {
            if(res && res.data){
               toastMessage('success', 'Job status updated successfully');
               history.push((status === 'Accepted') ? `/jobs/${jobID}` : '/jobs?reload=true');
            }else{
                toastMessage('error', (res && res.message) || 'Try again later');
            }
        });
    }

    return(
        <>
            {jobNotifyModal && <Modal jobTitle={jobTitle} t={t} jobData={jobData} title={t("sideNav.newJobRequest.title")} type={'notification'} showModal={jobNotifyModal} handleOk={updateJobStatus} handleCancel={() => setReasonModal(true)} footerOption1={t("sideNav.newJobRequest.accept")} footerOption2={t("sideNav.newJobRequest.decline")} handleModalClose={closeModal} isFromworker={true} />}
            {reasonModal && <ReasonModal title={t("sideNav.rejectJobRequest.title")} t={t} showModal={reasonModal} setReason={setReason} handleOk={() => updateJobStatus('Declined')} handleModalClose={closeModal} />}
        </>
    );
};

export default JobRequest;